import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_PsychosocialAssessment = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_PsychosocialAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>PSYCHOSOCIAL ASSESSMENT</h3></p>

                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtPatient' name='txtPatient' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtPatientDate' name='txtPatientDate' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>MR#:</span></td>
                        <td className='w-250'><span className='eleHeader'>Admission Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtMr' name='txtMr' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtAdmissionDate' name='txtAdmissionDate' className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Legal Status:</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbLegalStatus_1' name='cbLegalStatus_1' className='add-only' value='LegalStatus_1' />
                            Voluntary</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbLegalStatus_2' name='cbLegalStatus_2' className='add-only' value='LegalStatus_2' />
                            Involuntary</td>
                        <td className='w-500'>
                            <input type='checkbox' id='cbLegalStatus_3' name='cbLegalStatus_3' className='add-only' value='LegalStatus_3' />
                            Conservatorship (for Gravely Disabled Mentally Disordered Persons)</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Presenting Problem:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPresenting_1' name='cbPresenting_1' className='add-only' value='Presenting_1' />
                            Adjustment Disorder</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPresenting_2' name='cbPresenting_2' className='add-only' value='Presenting_2' />
                            Anxiety Disorder</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPresenting_3' name='cbPresenting_3' className='add-only' value='Presenting_3' />
                            Mood Disorder</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPresenting_4' name='cbPresenting_4' className='add-only' value='Presenting_4' />
                            Personality Disorder</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPresenting_5' name='cbPresenting_5' className='add-only' value='Presenting_5' />
                            Substance Abuse</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPresenting_6' name='cbPresenting_6' className='add-only' value='Presenting_6' /> Other: &nbsp;
                            <input type='text' id='txtPresenting_6' name='txtPresenting_6' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments' name='txtComments' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>History of Violence:</span>
                    <textarea id='txtHistoryViolence' name='txtHistoryViolence' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Suicide Potential:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSuicidePotential_1' name='cbSuicidePotential_1' className='add-only' value='SuicidePotential_1' />Significant sense of loss (loved one, pet, amployment)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSuicidePotential_2' name='cbSuicidePotential_2' className='add-only' value='SuicidePotential_2' />Significant sense of hardship (financial, legal)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSuicidePotential_3' name='cbSuicidePotential_3' className='add-only' value='SuicidePotential_3' />Significant sense of separation</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSuicidePotential_4' name='cbSuicidePotential_4' className='add-only' value='SuicidePotential_4' />Substance abuse or dependence</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSuicidePotential_5' name='cbSuicidePotential_5' className='add-only' value='SuicidePotential_5' />Significant unstable physical environment (below poverty level, lack of shelter, difficult foster placement, etc.)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSuicidePotential_6' name='cbSuicidePotential_6' className='add-only' value='SuicidePotential_6' />Family hx of suicide attempt</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSuicidePotential_7' name='cbSuicidePotential_7' className='add-only' value='SuicidePotential_7' />Previous pt suicide attempt </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSuicidePotential_8' name='cbSuicidePotential_8' className='add-only' value='SuicidePotential_8' />Significant depression</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Potential for Suicide:</span>
                    <input type='radio' id='rbPotentialSuicide_Yes' name='rbPotentialSuicide' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPotentialSuicide_No' name='rbPotentialSuicide' className='add-only' value='No' /> No If yes, refer to Social Service, place on close observation, notify physician

                    <textarea id='txtPotentialSuicideIfYes' name='txtPotentialSuicideIfYes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Suicidal Ideation/Plan:</span>
                    <input type='radio' id='rbCurrentSuicidalIdeation_Yes' name='rbCurrentSuicidalIdeation' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCurrentSuicidalIdeation_No' name='rbCurrentSuicidalIdeation' className='add-only' value='No' /> No If yes,implement suicide precautions notity physician, refer to Social Service

                    <textarea id='txtCurrentSuicidalIdeation' name='txtCurrentSuicidalIdeation' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Past Psychiatric Treatment:</span>
                    <textarea id='txtPastPsychiatricTreatment' name='txtPastPsychiatricTreatment' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age at Onset:</span></td>
                        <td className='w-375'><span className='eleHeader'># of Hospitalization:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAgeAtOnset' name='txtAgeAtOnset' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtHospitalization' name='txtHospitalization' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>History of Substance Use:</span>
                    <input type='radio' id='rbSubstanceUse_Yes' name='rbSubstanceUse' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSubstanceUse_No' name='rbSubstanceUse' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <b>(List each substance use)</b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Substance </span></td>
                        <td className='w-375'><span className='eleHeader'>Age of onset: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSubstance' name='txtSubstance' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtAgeOnset' name='txtAgeOnset' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Intensity:</span></td>
                        <td className='w-375'><span className='eleHeader'>Duration:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtIntensity' name='txtIntensity' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtDuration' name='txtDuration' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Pattern of use: </span></td>
                        <td className='w-375'><span className='eleHeader'>Consequences of use:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPatternUse' name='txtPatternUse' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtConsequences' name='txtConsequences' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Types of previous treatment(s):</span></td>
                        <td className='w-375'><span className='eleHeader'>Responses to treatment(s):</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTypes' name='txtTypes' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtResponses' name='txtResponses' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Living Situation:</span>
                    <textarea id='txtLivingSituation' name='txtLivingSituation' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Insurance:</span></td>
                        <td className='w-200'><span className='eleHeader'>Source of Income:</span></td>
                        <td className='w-150'><span className='eleHeader'>Amount:</span></td>
                        <td className='w-150'><span className='eleHeader'>Debts:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtInsurance' name='txtInsurance' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtSourceIncome' name='txtSourceIncome' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtAmount' name='txtAmount' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtDebts' name='txtDebts' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Recent Changes/Stressors:</span>
                    <textarea id='txtRecentChangesStressors' name='txtRecentChangesStressors' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Relevant Medical Consultations/History:</span>
                    <textarea id='txtRelevantMedicalConsultations' name='txtRelevantMedicalConsultations' className='add-only'></textarea>
                </p>
                <p className='w-750'><h3>SOCIAL HISTORY</h3></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Place of Birth:</span></td>
                        <td className='w-375'><span className='eleHeader'>Raised by:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPlaceBirth' name='txtPlaceBirth' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtRaisedBy' name='txtRaisedBy' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Came to (State)</span></td>
                        <td className='w-375'><span className='eleHeader'>When why:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCameState' name='txtCameState' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtWhenwhy' name='txtWhenwhy' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Siblings/Family Structure:</span>
                    <textarea id='txtSiblings' name='txtSiblings' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family History of Mental Illness:</span>
                    <input type='radio' id='rbFamilyHistory_Yes' name='rbFamilyHistory' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbFamilyHistory_No' name='rbFamilyHistory' className='add-only' value='No' /> No If yes, relation:
                    <textarea id='txtFamilyHistoryRelation' name='txtFamilyHistoryRelation' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family History of Drug and/or Alcohol Abuse:</span>
                    <input type='radio' id='rbFamilyHistoryDrug_Yes' name='rbFamilyHistoryDrug' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbFamilyHistoryDrug_No' name='rbFamilyHistoryDrug' className='add-only' value='No' /> No If yes,explain:
                    <textarea id='txtFamilyHistoryDrugExplain' name='txtFamilyHistoryDrugExplain' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Relationships W/Family:</span>
                    <textarea id='txtCurrentRelationshipsFamily' name='txtCurrentRelationshipsFamily' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other Social Relationships:</span>
                    <textarea id='txtOtherSocialRelationships' name='txtOtherSocialRelationships' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ethnic/Cultural Background:</span>
                    <textarea id='txtEthnic' name='txtEthnic' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Physical Abuse</span></td>
                        <td className='w-375'><span className='eleHeader'>Sexual Abuse as Perpetrator</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbPhysicalAbuse_Yes' name='rbPhysicalAbuse' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPhysicalAbuse_No' name='rbPhysicalAbuse' className='add-only' value='No' /> No

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbSexualAbuse_Yes' name='rbSexualAbuse' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSexualAbuse_No' name='rbSexualAbuse' className='add-only' value='No' /> No

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Sexual Abuse as Victim:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><b>If victim, is perpetrator known to patiet</b></td>
                        <td className='w-375'><b>Have charges been brought?</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbSexualAbuseVictim_Yes' name='rbSexualAbuseVictim' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSexualAbuseVictim_No' name='rbSexualAbuseVictim' className='add-only' value='No' /> No

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbSexualAbuseCharges_Yes' name='rbSexualAbuseCharges' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSexualAbuseCharges_No' name='rbSexualAbuseCharges' className='add-only' value='No' /> No

                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Spiritual Orientation</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbSpiritualOrientation_1' name='cbSpiritualOrientation_1' className='add-only' value='SpiritualOrientation_1' />Baptist </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbSpiritualOrientation_2' name='cbSpiritualOrientation_2' className='add-only' value='SpiritualOrientation_2' />Buddhist </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbSpiritualOrientation_3' name='cbSpiritualOrientation_3' className='add-only' value='SpiritualOrientation_3' />Catholic </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbSpiritualOrientation_4' name='cbSpiritualOrientation_4' className='add-only' value='SpiritualOrientation_4' />Christian </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbSpiritualOrientation_5' name='cbSpiritualOrientation_5' className='add-only' value='SpiritualOrientation_5' />Eastern </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbSpiritualOrientation_6' name='cbSpiritualOrientation_6' className='add-only' value='SpiritualOrientation_6' />Orthodox</td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbSpiritualOrientation_7' name='cbSpiritualOrientation_7' className='add-only' value='SpiritualOrientation_7' />Hindu </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbSpiritualOrientation_8' name='cbSpiritualOrientation_8' className='add-only' value='SpiritualOrientation_8' />Jehovah's </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbSpiritualOrientation_9' name='cbSpiritualOrientation_9' className='add-only' value='SpiritualOrientation_9' />Witness </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbSpiritualOrientation_10' name='cbSpiritualOrientation_10' className='add-only' value='SpiritualOrientation_10' />Jewish</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbSpiritualOrientation_11' name='cbSpiritualOrientation_11' className='add-only' value='SpiritualOrientation_11' />Muslim</td>
                        <td className='w-125'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSpiritualOrientation_12' name='cbSpiritualOrientation_12' className='add-only' value='SpiritualOrientation_12' /> Other: &nbsp;
                            <input type='text' id='txtSpiritualOrientation_12' name='txtSpiritualOrientation_12' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Religion of Family:</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_1' name='cbReligionSpiritualOrientation_1' className='add-only' value='ReligionSpiritualOrientation_1' />Baptist </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_2' name='cbReligionSpiritualOrientation_2' className='add-only' value='ReligionSpiritualOrientation_2' />Buddhist </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_3' name='cbReligionSpiritualOrientation_3' className='add-only' value='ReligionSpiritualOrientation_3' />Catholic </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_4' name='cbReligionSpiritualOrientation_4' className='add-only' value='ReligionSpiritualOrientation_4' />Christian </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_5' name='cbReligionSpiritualOrientation_5' className='add-only' value='ReligionSpiritualOrientation_5' />Eastern </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_6' name='cbReligionSpiritualOrientation_6' className='add-only' value='ReligionSpiritualOrientation_6' />Orthodox</td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_7' name='cbReligionSpiritualOrientation_7' className='add-only' value='ReligionSpiritualOrientation_7' />Hindu </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_8' name='cbReligionSpiritualOrientation_8' className='add-only' value='ReligionSpiritualOrientation_8' />Jehovah's </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_9' name='cbReligionSpiritualOrientation_9' className='add-only' value='ReligionSpiritualOrientation_9' />Witness </td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_10' name='cbReligionSpiritualOrientation_10' className='add-only' value='ReligionSpiritualOrientation_10' />Jewish</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_11' name='cbReligionSpiritualOrientation_11' className='add-only' value='ReligionSpiritualOrientation_11' />Muslim</td>
                        <td className='w-125'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbReligionSpiritualOrientation_12' name='cbReligionSpiritualOrientation_12' className='add-only' value='ReligionSpiritualOrientation_12' /> Other: &nbsp;
                            <input type='text' id='txtReligionSpiritualOrientation_12' name='txtReligionSpiritualOrientation_12' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Sexual Orientation:</span>
                            <input type='text' id='txtSexualOrientation' name='txtSexualOrientation' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Currently Sexually Active?</span></td>
                        <td className='w-375'><span className='eleHeader'>Awareness of HIV Protection:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbCurrentlySexuallyActive_Yes' name='rbCurrentlySexuallyActive' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrentlySexuallyActive_No' name='rbCurrentlySexuallyActive' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAwarenessHiv_Good' name='rbAwarenessHiv' className='add-only' value='Good' /> Good &nbsp;
                            <input type='radio' id='rbAwarenessHiv_Fair' name='rbAwarenessHiv' className='add-only' value='Fair' /> Fair &nbsp;
                            <input type='radio' id='rbAwarenessHiv_Poor' name='rbAwarenessHiv' className='add-only' value='Poor' /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Accepts HIV Education:</span></td>
                        <td className='w-375'><span className='eleHeader'>Ever Married:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbHivEducation_Yes' name='rbHivEducation' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHivEducation_No' name='rbHivEducation' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbEverMarried_Yes' name='rbEverMarried' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbEverMarried_No' name='rbEverMarried' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Children:</span>
                            <input type='text' id='txtChildren' name='txtChildren' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Education Level:</span>
                            <input type='text' id='txtEducationLevel' name='txtEducationLevel' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Special Education History:</span>

                            <input type='radio' id='rbSpecialEducationHistory_Yes' name='rbSpecialEducationHistory' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSpecialEducationHistory_No' name='rbSpecialEducationHistory' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Employment History:</span>
                    <textarea id='txtEmploymentHistory' name='txtEmploymentHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Military Service:</span>
                    <textarea id='txtMilitaryService' name='txtMilitaryService' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Criminal History</span>
                    <input type='radio' id='rbCriminalHistory_Yes' name='rbCriminalHistory' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCriminalHistory_No' name='rbCriminalHistory' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Parole/Probation Officer:</span>
                    <textarea id='txtParoleProbationOfficer' name='txtParoleProbationOfficer' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Personal Strengths/Assets:</span>
                    <textarea id='txtPersonalStrengthsAssets' name='txtPersonalStrengthsAssets' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Motivation for Change/Treatment Acceptance:</span>
                    <textarea id='txtMotivationChangeTreatmentAcceptance' name='txtMotivationChangeTreatmentAcceptance' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Recreation/Leisure Activities:</span>
                    <textarea id='txtRecreationLeisurActivities' name='txtRecreationLeisurActivities' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Peer Group:</span>
                    <textarea id='txtPeerGroup' name='txtPeerGroup' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>MENTAL STATUS</h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>Appearance:</span>
                    <textarea id='txtAppearance' name='txtAppearance' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Attitude:</span>
                    <textarea id='txtAttitude' name='txtAttitude' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Orientation:</span>
                    <textarea id='txtOrientation' name='txtOrientation' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Motor Activity:</span>
                    <textarea id='txtMotorActivity' name='txtMotorActivity' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Mood:</span>
                    <textarea id='txtMood' name='txtMood' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Affect:</span>
                    <textarea id='txtAffect' name='txtAffect' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Speech:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Speech_1' />
                            Appropriate</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Speech_2' />
                            Disorganized</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Speech_3' />
                            Hyperverbal</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_4' name='cbSpeech_4' className='add-only' value='Speech_4' />
                            Incoherent</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_5' name='cbSpeech_5' className='add-only' value='Speech_5' />
                            Loud</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_6' name='cbSpeech_6' className='add-only' value='Speech_6' />
                            Mumbled</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_7' name='cbSpeech_7' className='add-only' value='Speech_7' />
                            Mute</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_8' name='cbSpeech_8' className='add-only' value='Speech_8' />
                            Neologisms</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_9' name='cbSpeech_9' className='add-only' value='Speech_9' />
                            Pressured</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_10' name='cbSpeech_10' className='add-only' value='Speech_10' />
                            Slurred</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_11' name='cbSpeech_11' className='add-only' value='Speech_11' />
                            Soft </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_12' name='cbSpeech_12' className='add-only' value='Speech_12' />
                            Stutter </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_13' name='cbSpeech_13' className='add-only' value='Speech_13' />
                            Tangential</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSpeech_14' name='cbSpeech_14' className='add-only' value='Speech_14' /> Other: &nbsp;
                            <input type='text' id='txtSpeech_14' name='txtSpeech_14' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Sleep:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSleep_1' name='cbSleep_1' className='add-only' value='Sleep_1' />
                            Normal </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSleep_2' name='cbSleep_2' className='add-only' value='Sleep_2' />
                            Excessive </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSleep_3' name='cbSleep_3' className='add-only' value='Sleep_3' />
                            Insufficient </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSleep_4' name='cbSleep_4' className='add-only' value='Sleep_4' />
                            Interrupted </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSleep_5' name='cbSleep_5' className='add-only' value='Sleep_5' />
                            Irregular </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSleep_6' name='cbSleep_6' className='add-only' value='Sleep_6' />
                            Poor </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSleep_7' name='cbSleep_7' className='add-only' value='Sleep_7' />
                            Primary insomnia </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSleep_8' name='cbSleep_8' className='add-only' value='Sleep_8' />
                            Terminal insomnia</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSleep_9' name='cbSleep_9' className='add-only' value='Sleep_9' /> Other: &nbsp;
                            <input type='text' id='txtSleep_9' name='txtSleep_9' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Perceptions:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>AH/VH:</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbPerceptions_1' name='cbPerceptions_1' className='add-only' value='Perceptions_1' />
                            Accusatory </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbPerceptions_2' name='cbPerceptions_2' className='add-only' value='Perceptions_2' />
                            Command type </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbPerceptions_3' name='cbPerceptions_3' className='add-only' value='Perceptions_3' />
                            Derogatory </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbPerceptions_4' name='cbPerceptions_4' className='add-only' value='Perceptions_4' />
                            Persecutory</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbPerceptions_5' name='cbPerceptions_5' className='add-only' value='Perceptions_5' />
                            Religious </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbPerceptions_6' name='cbPerceptions_6' className='add-only' value='Perceptions_6' />
                            Flares/lights</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbPerceptions_7' name='cbPerceptions_7' className='add-only' value='Perceptions_7' />
                            Recognizable </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbPerceptions_8' name='cbPerceptions_8' className='add-only' value='Perceptions_8' />
                            Tactile</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPerceptions_9' name='cbPerceptions_9' className='add-only' value='Perceptions_9' /> Other: &nbsp;
                            <input type='text' id='txtPerceptions_9' name='txtPerceptions_9' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Thought Content:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>DEL:</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_1' name='cbThoughtContent_1' className='add-only' value='ThoughtContent_1' />
                            Bizarre </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_2' name='cbThoughtContent_2' className='add-only' value='ThoughtContent_2' />
                            Death </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_3' name='cbThoughtContent_3' className='add-only' value='ThoughtContent_3' />
                            Erotomanic </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_4' name='cbThoughtContent_4' className='add-only' value='ThoughtContent_4' />
                            Grandiose</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_5' name='cbThoughtContent_5' className='add-only' value='ThoughtContent_5' />
                            Hopeless/holpless </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_6' name='cbThoughtContent_6' className='add-only' value='ThoughtContent_6' />
                            Ideas of reference </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_7' name='cbThoughtContent_7' className='add-only' value='ThoughtContent_7' />
                            Paranoid </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_8' name='cbThoughtContent_8' className='add-only' value='ThoughtContent_8' />
                            Persecutory</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_9' name='cbThoughtContent_9' className='add-only' value='ThoughtContent_9' />
                            Preoccupied </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_10' name='cbThoughtContent_10' className='add-only' value='ThoughtContent_10' />
                            Somatic </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_11' name='cbThoughtContent_11' className='add-only' value='ThoughtContent_11' />
                            Suicide </td>
                        <td className='w-600'>
                            <input type='checkbox' id='cbThoughtContent_12' name='cbThoughtContent_12' className='add-only' value='ThoughtContent_12' />
                            Thought Broadcasting/insertion </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbThoughtContent_13' name='cbThoughtContent_13' className='add-only' value='ThoughtContent_13' /> Other: &nbsp;
                            <input type='text' id='txtThoughtContent_13' name='txtThoughtContent_13' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Thought Process:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_1' name='cbThoughtProcess_1' className='add-only' value='ThoughtProcess_1' />
                            Circular </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_2' name='cbThoughtProcess_2' className='add-only' value='ThoughtProcess_2' />
                            Disorganized </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_3' name='cbThoughtProcess_3' className='add-only' value='ThoughtProcess_3' />
                            Fixed ideas </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_4' name='cbThoughtProcess_4' className='add-only' value='ThoughtProcess_4' />
                            Loose</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_5' name='cbThoughtProcess_5' className='add-only' value='ThoughtProcess_5' />
                            Perseverating </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_6' name='cbThoughtProcess_6' className='add-only' value='ThoughtProcess_6' />
                            Ruminating </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_7' name='cbThoughtProcess_7' className='add-only' value='ThoughtProcess_7' />
                            Tangential </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_8' name='cbThoughtProcess_8' className='add-only' value='ThoughtProcess_8' />
                            Thought blocking</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbThoughtProcess_9' name='cbThoughtProcess_9' className='add-only' value='ThoughtProcess_9' /> Other: &nbsp;
                            <input type='text' id='txtThoughtProcess_9' name='txtThoughtProcess_9' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Memory:</h3></p>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Immediate:</span></td>
                        <td className='w-250'><span className='eleHeader'>Recent:</span></td>
                        <td className='w-250'><span className='eleHeader'>Remote:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtImmediate' name='txtImmediate' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtRecent' name='txtRecent' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtRemote' name='txtRemote' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Attention:</span>
                    <textarea id='txtAttention' name='txtAttention' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Absraction:</span>
                    <b>Proverb:</b>
                    <br />
                    <textarea id='txtAbsractionProverb' name='txtAbsractionProverb' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Judgment/Insight:</span>
                    <textarea id='txtJudgmentInsight' name='txtJudgmentInsight' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Impression of Intelligence:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpressionIntelligence_1' name='cbImpressionIntelligence_1' className='add-only' value='ImpressionIntelligence_1' />
                            Average </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpressionIntelligence_2' name='cbImpressionIntelligence_2' className='add-only' value='ImpressionIntelligence_2' />
                            Below average </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpressionIntelligence_3' name='cbImpressionIntelligence_3' className='add-only' value='ImpressionIntelligence_3' />
                            Above average </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpressionIntelligence_4' name='cbImpressionIntelligence_4' className='add-only' value='ImpressionIntelligence_4' />
                            Intellectual Disabilities</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments:</span>
                    <textarea id='txtAdditionalComments' name='txtAdditionalComments' className='add-only'></textarea>
                </p>


            </div>
        </form >

    )
}











